/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Intermediary } from './Intermediary';
import {
    IntermediaryFromJSON,
    IntermediaryFromJSONTyped,
    IntermediaryToJSON,
} from './Intermediary';

/**
 * 
 * @export
 * @interface IntermediaryDetail
 */
export interface IntermediaryDetail {
    /**
     * 
     * @type {string}
     * @memberof IntermediaryDetail
     */
    effectiveDate: string;
    /**
     * 
     * @type {Intermediary}
     * @memberof IntermediaryDetail
     */
    intermediaryDetails: Intermediary;
}

/**
 * Check if a given object implements the IntermediaryDetail interface.
 */
export function instanceOfIntermediaryDetail(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "effectiveDate" in value;
    isInstance = isInstance && "intermediaryDetails" in value;

    return isInstance;
}

export function IntermediaryDetailFromJSON(json: any): IntermediaryDetail {
    return IntermediaryDetailFromJSONTyped(json, false);
}

export function IntermediaryDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntermediaryDetail {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'effectiveDate': json['EffectiveDate'],
        'intermediaryDetails': IntermediaryFromJSON(json['IntermediaryDetails']),
    };
}

export function IntermediaryDetailToJSON(value?: IntermediaryDetail | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'EffectiveDate': value.effectiveDate,
        'IntermediaryDetails': IntermediaryToJSON(value.intermediaryDetails),
    };
}

